import { number } from "prop-types";

export function formsToFilterBuilder(forms) {

    const segments = new Map();

    for(var i = 0; i<forms.length; i++) {

        for(var j = 0; j<forms[i].segments.length; j++) {

            if (!segments.has(j)) {
                let newSegment = {
                    type: forms[i].segments[j].type,
                    question: forms[i].segments[j].question,
                    answers: new Map(),
                    multiselect: false
                }
                segments.set(j, newSegment);
            }
            let segment = segments.get(j);
            let numberOfSelections = 0;
            for(var k = 0; k<forms[i].segments[j].answers.length; k++) {
                let answer;
               
                if (!segment.answers.has(k)) {
                    answer = {
                        type: forms[i].segments[j].answers[k].type,
                        amount: 0,
                        answers: []
                    }
                    
                    segment.answers.set(k, answer);
                }
                answer = segment.answers.get(k);
                if(forms[i].segments[j].answers[k].answer.trim().length > 0 && !answer.answers.includes(forms[i].segments[j].answers[k].answer)) {
                    answer.answers.push(forms[i].segments[j].answers[k].answer);
                }
                if(forms[i].segments[j].type == 'radial') {
                    if (forms[i].segments[j].answers[k].selected) {
                        answer.amount = answer.amount + 1;
                        numberOfSelections++;
                    }
                }
            }
            if (numberOfSelections > 1) {
                segment.multiselect = true;
            }
        }
    }

    const finalSegments = Array.from(segments, ([key, value]) => (value ));

    return { segments: finalSegments };
}

export function gatherForms(board) {
    const forms = [];
    for (var i=0; i<board.columns.length; i++) {
        for (var j=0; j<board.columns[i].cards.length; j++) {
            forms.push(board.columns[i].cards[j].form);
        }
    }
    return forms;
}

export function buildFilterForm(numberOfSegments) {
    const filterForm = {};
    for(var i=0; i<numberOfSegments; i++) {
        filterForm[i] = {
            radial: [],
            freeText: []
        };
    }
    return filterForm;
}